import React from 'react';

const Admissions = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <div className="text-3xl font-bold mb-4">Admissions Information</div>
        <p className="mb-4">
          Hamilton College of the Bahamas seeks students who have a desire for career ministry, Counseling, Educational services, Business and Engineering. HCB is committed to a policy of equal opportunity in the recruitment and admission of students and other student services and activities. HCB does not discriminate on the basis of age, sex, race, color, religion, disability, sexual orientation, marital status, veteran status or national origin.
        </p>
        
        <h2 className="text-2xl font-bold mb-4">Criteria for Admission</h2>
        <p className="mb-4">
          Admission into Hamilton College of the Bahamas is open to students seeking education in a variety of programs. Admissions into our Non Secular Masters Degree programs require at least a Bachelors degree. While admissions into our Bachelors program, requires at least an Associate's degree.
        </p>
        
        <h2 className="text-2xl font-bold mb-4">Academic Calendar</h2>  
        <p className="mb-4">
          Admission to Hamilton College of the Bahamas may be attained at any start of each term which is a rolling admission. Student can enroll at anytime and class will start at the beginning of each month.
        </p>
      </div>
    </div>
  );
};

export default Admissions;